/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_KpfsInputs */

const de__field_kpfs = /** @type {(inputs: _Field_KpfsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KPF`)
};

/**

* @param {_Field_KpfsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_kpfs = /** @type {((inputs?: _Field_KpfsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_KpfsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kpfs(inputs)
});